import styled from 'styled-components'

import { StyledContainer } from 'components/Container/Container.styles'
import { StyledDownloadBanner } from 'components/DownloadBanner/DownloadBanner.styles'
import { StyledHeader } from 'components/Header/Header.styles'
import { StyledRadiantSpinner } from 'components/RadiantSpinner/RadiantSpinner.styles'
import { StyledUpdateSubscriptionModal } from 'components/UpdateSubscriptionModal/UpdateSubscriptionModal.styles'

import { StyledAccount } from 'modules/unsubscribe/components/Account/Account.styles'
import { StyledContactSupport } from 'modules/unsubscribe/components/ContactSupport/ContactSupport.styles'
import { StyledDetailsTab } from 'modules/unsubscribe/components/DetailsTabs/DetailsTab.styles'
import { StyledPinnedNote } from 'modules/unsubscribe/components/PinnedNote/PinnedNote.styles'
import { StyledSubscriptions } from 'modules/unsubscribe/components/Subscriptions/Subscriptions.styles'

import { SubscriptionContainer, SubscriptionTitle } from 'common-styles'

import { FemiColor } from '../../constants'

export const StyledFemiScope = {
  Wrapper: styled.div`
    min-height: var(--full-height, 100vh);
    background-color: ${FemiColor.WHITE};

    --app-font-family: 'Poppins', sans-serif;

    ${StyledDownloadBanner.Wrapper} {
      padding: 0 16px;
      align-items: center;

      &:after {
        display: none;
      }

      img {
        width: 40px;
        height: 40px;
        margin: 0 12px 0 0;
        border-radius: 11px;
        box-shadow: 0 4px 10px rgba(12, 17, 22, 0.24);
      }
    }

    ${StyledDownloadBanner.LogoContainer} {
      align-items: center;
    }

    ${StyledDownloadBanner.Logo} {
      padding-top: 0;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
    }

    ${StyledDownloadBanner.OpenIn} {
      margin-top: 0;
      color: ${FemiColor.GRAY};
      font-size: 14px;
      line-height: 20px;
    }

    ${StyledDownloadBanner.Button} {
      margin-top: 0;
      padding: 6px 24px;
      border-radius: 16px;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: 0;
      text-transform: none;
    }

    ${StyledContainer.Container} {
      max-width: 390px;
    }

    ${StyledHeader.Wrapper} {
      box-shadow: none;
    }

    ${SubscriptionTitle} {
      margin-bottom: 24px;
      font-family: 'Lora', serif;
      font-size: 28px;
      font-weight: 600;
      line-height: 36px;
    }

    ${StyledDetailsTab.TabsContainer} {
      border-bottom: 1px solid ${FemiColor.GRAY_LIGHT};
    }

    ${StyledDetailsTab.Tab} {
      width: 145px;
      padding-bottom: 16px;
      font-size: 15px;
      font-weight: 500;
      line-height: 22px;

      &:first-of-type {
        margin-right: 20px;
      }
    }

    ${SubscriptionContainer.Root} {
      border: 1px solid ${FemiColor.GRAY_BG};
      border-radius: 20px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);

      & > div:first-of-type {
        border-top-color: ${FemiColor.GRAY_LIGHT};
      }

      & > div:last-of-type {
        border-bottom-color: ${FemiColor.GRAY_LIGHT};
      }
    }

    ${SubscriptionContainer.CardTitle} {
      color: ${FemiColor.BLACK};
      font-size: 17px;
      font-weight: 500;
      line-height: 26px;
    }

    ${SubscriptionContainer.InfoValue} {
      font-weight: 500;
    }

    ${SubscriptionContainer.ResetPassword} {
      color: ${FemiColor.BLACK};
      font-size: 13px;
      line-height: 16px;
    }

    ${StyledAccount.InfoRow} {
      line-height: 26px;

      & > span:first-of-type {
        color: ${FemiColor.GRAY};
      }
    }

    ${StyledSubscriptions.SubscriptionRow} {
      font-size: 17px;
      line-height: 26px;

      & > span:first-of-type {
        color: ${FemiColor.GRAY};
      }
    }

    ${StyledSubscriptions.Status}[data-status='active'],
    ${StyledSubscriptions.Status}[data-status='trial'] {
      color: ${FemiColor.GREEN};
    }

    ${StyledSubscriptions.Status}[data-status='paused'] {
      color: ${FemiColor.ORANGE};
    }

    ${StyledSubscriptions.Status}[data-status='canceled'],
    ${StyledSubscriptions.Status}[data-status='withdrawn'],
    ${StyledSubscriptions.Status}[data-status='not_active'] {
      color: ${FemiColor.RED};
    }

    ${StyledSubscriptions.Separator} {
      background: ${FemiColor.GRAY_LIGHT};
    }

    ${StyledContactSupport.Question} {
      font-size: 12px;
      line-height: 18px;
    }

    ${StyledContactSupport.SupportLink},
    ${StyledContactSupport.HelpCenterLink} {
      color: ${FemiColor.PINK};
      font-size: 12px;
      line-height: 18px;
    }

    ${StyledPinnedNote.Wrapper} {
      background: ${FemiColor.GRAY_BG};
    }

    ${StyledPinnedNote.PinContainer} {
      background-color: ${FemiColor.PINK_LIGHT};
    }

    ${StyledPinnedNote.Note} {
      color: ${FemiColor.BLACK};
      font-size: 15px;
      line-height: 22px;
    }

    ${StyledRadiantSpinner.Radius}::after {
      background-color: ${FemiColor.PINK};
    }

    ${StyledUpdateSubscriptionModal.Wrapper} {
      background-color: rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(16px);
    }

    ${StyledUpdateSubscriptionModal.Content} {
      width: 342px;
      max-width: calc(100% - 48px);
      border-radius: 20px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);

      button {
        width: 100%;
        max-width: none;
        height: 56px;
        border-radius: 16px;
        background-color: ${FemiColor.BLACK};
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
      }
    }

    ${StyledUpdateSubscriptionModal.Title} {
      margin-bottom: 16px;
      font-family: 'Lora', serif;
      font-size: 28px;
      font-weight: 600;
      line-height: 36px;
    }

    ${StyledUpdateSubscriptionModal.Text} {
      color: ${FemiColor.GRAY};
      font-size: 15px;
      line-height: 22px;
    }
  `,
}
